import { useNavigate } from "react-router-dom";
import { MaIcon, type IconName } from "./MaIcon";

export type NavTab = "discover" | "now" | "eat" | "search" | "saved" | "profile";

const TABS: { id: NavTab; icon: IconName; label: string; route: string }[] = [
  { id: "discover", icon: "map",      label: "Discover", route: "/discover" },
  { id: "now",      icon: "clock",    label: "Now",      route: "/now" },
  // EAT! lives between Now and Find. Six tabs is the upper limit for
  // mobile bottom nav (~16% width each). If layout pressure shows up on
  // 320 px screens, consider truncating labels rather than reorganising
  // — the user prefers EAT! visible from anywhere.
  { id: "eat",      icon: "food",     label: "Eat!",     route: "/eat" },
  { id: "search",   icon: "search",   label: "Find",     route: "/search" },
  { id: "saved",    icon: "bookmark", label: "Saved",    route: "/saved" },
  { id: "profile",  icon: "user",     label: "You",      route: "/you" },
];

interface Props {
  active?: NavTab;
  onChange?: (tab: NavTab) => void;
}

export function MaBottomNav({ active = "discover", onChange }: Props) {
  const navigate = useNavigate();
  return (
    <div style={{
      position: "absolute", bottom: 0, left: 0, right: 0, zIndex: 30,
      background: "var(--ma-cream)",
      borderTop: "var(--ma-border) solid var(--ma-ink)",
      paddingBottom: "calc(env(safe-area-inset-bottom, 0px) + 12px)",
      paddingTop: 8,
      display: "flex",
    }}>
      {TABS.map((t) => {
        const on = t.id === active;
        return (
          <button key={t.id} onClick={() => {
            if (onChange) onChange(t.id);
            navigate(t.route);
          }} style={{
            flex: 1, display: "flex", flexDirection: "column", alignItems: "center", gap: 2,
            background: "transparent", border: "none", padding: "6px 0 4px", cursor: "pointer",
            color: on ? "var(--ma-ink)" : "var(--ma-ink-soft)", position: "relative",
          }}>
            {on && (
              <div style={{
                position: "absolute", top: 0, left: "50%", transform: "translateX(-50%)",
                width: 28, height: 3, background: "var(--ma-brick)",
              }} />
            )}
            <MaIcon name={t.icon} size={22} stroke={on ? 2 : 1.5} />
            <span className="ma-mono" style={{
              fontSize: 9, letterSpacing: "0.1em", textTransform: "uppercase",
              fontWeight: on ? 600 : 400,
            }}>{t.label}</span>
          </button>
        );
      })}
    </div>
  );
}
